import TableOfContentSidebar, {
  TableOfContentSidebarProps,
} from './TableOfContentSidebar.component';

export type TableOfContentSidebarType = TableOfContentSidebarProps;

export default TableOfContentSidebar;
